import styled, { css } from 'styled-components';

type ContainerProps = {
  $isFinished: boolean;
  $animationDuration: number;
};

type ProgressProps = {
  $progress: number;
  $animationDuration: number;
};

export const Container = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  z-index: 9999;
  pointer-events: none;
  opacity: ${({ $isFinished }) => ($isFinished ? 0 : 1)};
  transition: opacity ${({ $animationDuration }) => $animationDuration}ms linear;
`;

const progressTransform = css<ProgressProps>`
  transform: translateX(${({ $progress }) => (-1 + $progress) * 100}%);
  transition: transform ${({ $animationDuration }) => $animationDuration}ms ease;
  will-change: transform;
`;

export const Bar = styled.div<ProgressProps>`
  ${progressTransform};

  width: 100%;
  height: 100%;
  background: var(--brand-main);
`;

export const Glow = styled.div<ProgressProps>`
  ${progressTransform};

  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(76, 139, 245, 0),
    var(--brand-main)
  );
  filter: blur(6px);
`;
